import { defineComponent } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'ItineraryWaypointFollowKitInstructions',
    components: {
        BasicCard: __vue_component__,
    },
});

export { script as default };
